import axiosInstance from "./AxiosInstance";

class CandidateService {
    constructor() {
        this.endpoint = "api/candidates";
    }

    async getDocumentsByCandidates(id) {
        var url = `${this.endpoint}/${id}/documents?PageIndex=1&PageSize=10000000`;
        return axiosInstance.get(url).then((response) => response.data);
    }
    async getCandidateAgentMembers(params) {
        var url = `${this.endpoint}/${params.candidateID}/agents`;
        return axiosInstance.get(url, { params: { ...params, PageIndex: 1, PageSize: 100000000 } }).then((response) => response.data);
    }
    deleteCandidateAgent = async(data) => {
        var url = `${this.endpoint}/agents/${data.eventAgentID}`;
        return axiosInstance.delete(url).then((response) => response.data);
    }
    
    addCandidateAgentMember = async (data) => {
        var url = `${this.endpoint}/agents`;
        return axiosInstance.post(url, data).then((response) => response.data);
    }
    addCandidateDocument = async (data) => {
        var url = `${this.endpoint}/documents`;
        return axiosInstance.post(url, data).then((response) => response.data);
    }
    async getUsersByID(id) {
        var url = `${this.endpoint}/${id}/users`;
        return axiosInstance.get(url).then((response) => response.data);
    };
    async getAll(params) {
        try {
            const response = await axiosInstance.get(`${this.endpoint}`, {
                params
            });

            return response.data;
        } catch (error) {
            console.error("Error fetching data:", error);
            throw error;
        }
    }

    async getByID(id) {
        try {
            const response = await axiosInstance.get(`${this.endpoint}/${id}`);
            return response.data;
        } catch (error) {
            console.error("Error fetching data:", error);
            throw error;
        }
    }

    async create(data) {
        try {
            const response = await axiosInstance.post(`${this.endpoint}`, data);
            return response.data;
        } catch (error) {
            console.error("Error updating candidate:", error);
        }
    }

    async update(id, data) {
        try {
            const response = await axiosInstance.patch(`${this.endpoint}/${id}`, data);
            return response.data;
        } catch (error) {
            console.error("Error updating candidate:", error);
        }
    }
}

const candidateService = new CandidateService();

export { candidateService };
